import Autocomplete from "../../library/Autocomplete";
import COUNTRIES from "./countries";
import { isAllowedFilterField } from "../../../utils/UserHelper";

function CountriesAutocomplete(props: any) {
  return <Autocomplete
          id="countriesAutocomplete"
          placeholder="Countries"
          reactKey="countriesAutocomplete"
          labelKey="name"
          onChange={props.onChange}
          onBlur={props.onBlur}
          style={props.style}
          options={props.options ? props.options : COUNTRIES}
          selected={props.selected}
          paginate={false}
          maxResults={COUNTRIES.length+1}
          maxDisplayTokens={5}
          reactRef={props.reactRef}
          onKeyDown={props.onKeyDown}
          useIncludeExclude={props.useIncludeExclude && isAllowedFilterField("countriesExclude")}
          defaultIncludeExclude={props.defaultIncludeExclude}
          includeExcludeOnChange={props.includeExcludeOnChange}
          keepDropdownOpen={true}
          multiple={props.multiple}
        />;
}

export default CountriesAutocomplete;
